// extracted by mini-css-extract-plugin
module.exports = {"unbounded":"input_unbounded__22zqL","input":"input_input__1IAcy"};